import { createAsyncThunk } from "@reduxjs/toolkit"
import apiRequest from "../../lib/http"



export const getBaseUserById = createAsyncThunk('user/getBaseUserById', async (userId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/user/${userId}`)
    return response.data


  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch customer'
    return rejectWithValue(errorMessage)
  }
})

export const getBaseUserByIdAnonymous = createAsyncThunk('user/getBaseUserById', async (userId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/customUsers/${userId}/anonymous`)
    return response.data


  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch customer'
    return rejectWithValue(errorMessage)
  }
})

export const getUserStatusesForFilterUtils = createAsyncThunk('user/getUserStatusesForFilterUtils', async (_, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get('/customUsers/statuses/filters/utils')
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch contact-groups'
    return rejectWithValue(errorMessage)
  }
})

export const getAllAffiliatesForFilterUtils = createAsyncThunk('user/getAllAffiliatesForFilterUtils', async (_, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get('/affiliates/filters/utils')
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch contact-groups'
    return rejectWithValue(errorMessage)
  }
})

export const getAllCustomUsersForFilterUtils = createAsyncThunk('user/getAllCustomUsersForFilterUtils', async (_, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get('/customUsers/filters/utils')
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch custom users'
    return rejectWithValue(errorMessage)
  }
})

export const getCreatorsForFilterUtils = createAsyncThunk('user/getCreatorsForFilterUtils', async (_, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get('/filters/creators')
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch creators'
    return rejectWithValue(errorMessage)
  }
})